function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo-axelent_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M49.4 27L72 4.2H49.3L38.1 15.6 27 4.3H4.3L26.8 27 4.3 49.6h22.8l11-11.2 11 11.1.2.2H72L49.4 27z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.3 2.7a4.3 4.3 0 014-2.7H27c1.2 0 2.3.5 3 1.3l8.2 8.2 8.2-8.2c.8-.8 1.9-1.3 3-1.3H72a4.3 4.3 0 013 7.4L55.6 27 75 46.5a4.3 4.3 0 01-3 7.4H49.2c-1.1 0-2.2-.5-3-1.3l-.2-.1-8-8-8 8-.1.1c-.8.8-2 1.3-3 1.3H4.2c-1.6 0-3-1-3.8-2.4-.9-1.7-.5-3.7.8-5L20.7 27 1.3 7.4a4.3 4.3 0 01-1-4.7zm24.8 42.6l10-10a4.3 4.3 0 016 0l10 10h10.5L46.4 30a4.3 4.3 0 010-6L61.6 8.5H51l-10 10a4.3 4.3 0 01-6 0l-10-10H14.7L29.9 24a4.3 4.3 0 010 6L14.7 45.4H25z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.4 27L72 4.2H49.3L38.1 15.6 27 4.3H4.3L26.8 27 4.3 49.6h22.8l11-11.2 11 11.1.2.2H72L49.4 27z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.2 3.5C2.6 2.6 3.4 2 4.3 2H27c.6 0 1.2.2 1.6.6l9.6 9.6 9.6-9.6c.4-.4 1-.6 1.6-.6H72a2.3 2.3 0 011.6 3.8L52.6 27l21 21c.6.7.8 1.8.3 2.7-.4.8-1.1 1.3-2 1.3H49.3c-.6 0-1.2-.3-1.6-.7l-.1-.2-9.5-9.4-9.4 9.4-.2.2c-.4.4-1 .7-1.6.7H4.3c-.8 0-1.6-.5-2-1.3-.5-1-.3-2 .4-2.7l20.9-21-21-21c-.6-.6-.8-1.6-.4-2.4zM26 47.3l10.5-10.6a2.3 2.3 0 013.2 0l10.6 10.6h16.1L47.8 28.6c-.4-.5-.7-1-.7-1.6 0-.7.3-1.2.7-1.7L66.4 6.6H50.3L39.7 17.2a2.3 2.3 0 01-3.2 0L26 6.6H9.8l18.6 18.7c.4.5.7 1 .7 1.6 0 .7-.3 1.2-.7 1.7L9.8 47.3H26z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27 49.6v-.2L49.5 27 27 4.3H4.3L26.8 27 4.3 49.5H27z",
  fill: "#F8DC00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.6 31H103l5.2-9.3 1.3 9.2zM86 40.6h11.5l1.8-3.1h11.3l.4 3.1h11.5l-5.8-27.2h-13.3L86 40.7z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.4 26.5l-7.9-13h12.7l2.8 5.9 5.3-6H160l-13.4 13 9.2 14.3h-13.3l-3.5-7-6.6 7h-13.3l15.3-14.2zm27.8-13h29l-1.4 6.6h-18.3l-.7 3.7h16.9l-1.4 6.6h-17l-.7 3.7h18.2l-1.4 6.6h-29l5.8-27.2zm33.5 0h10.8l-4.2 19.9H219l-1.6 7.3H190l5.7-27.2zm30.8 0h29L254 20h-18.3l-.7 3.7h17l-1.4 6.6h-17l-.7 3.7H251l-1.4 6.6h-29l5.8-27.2zm34.5 0h12.2l7.8 15 3.3-15h10.3l-5.8 27.2H277l-8.2-15.3h-.1l-3.2 15.3H255l5.8-27.2zm45 6.8h-10l1.4-6.9h30.7l-1.4 7h-10l-4.4 20.3h-10.7l4.3-20.4z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.8 42.2l-.5-3.2h-9.1l-1.9 3.2H83.4L102.7 12h15.1l6.5 30.2h-14.5zm-1.9-12.7l-.4-3.5-2 3.5h2.4z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M141.6 42.2l-3-6-5.6 6h-17.5l17-16L124 12h16l2.3 4.8 4.4-4.8h16.8l-15.1 14.7 10 15.5h-16.8z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.4 26.5l-7.9-13h12.7l2.8 5.9 5.3-6H160l-13.4 13 9.2 14.3h-13.3l-3.5-7-6.6 7h-13.3l15.3-14.2z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M154.6 42.2L161 12h32l-2 9.5h-18.3l-.2.8h17l-2 9.5h-17l-.2.8h18.3l-2 9.6h-32z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M162.2 13.5h29l-1.4 6.6h-18.3l-.7 3.7h16.9l-1.4 6.6h-17l-.7 3.7h18.2l-1.4 6.6h-29l5.8-27.2z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M188.2 42.2l6.4-30.2h13.7L204 32h16.7l-2.1 10.2h-30.4z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M195.7 13.5h10.8l-4.2 19.9H219l-1.6 7.3H190l5.7-27.2z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M218.9 42.2l6.4-30.2h32l-2 9.5H237l-.2.8h17l-2 9.5h-17l-.2.8H253l-2 9.6h-32z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M226.5 13.5h29L254 20h-18.3l-.7 3.7h17l-1.4 6.6h-17l-.7 3.7H251l-1.4 6.6h-29l5.8-27.2z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M276.1 42.2l-6.8-12.7-2.7 12.7h-13.2l6.4-30.2H274l6.4 12.5L283 12h13.3L290 42.2h-14z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M261 13.5h12.2l7.8 15 3.3-15h10.3l-5.8 27.2H277l-8.2-15.3h-.1l-3.2 15.3H255l5.8-27.2z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M299.8 42.2l4.3-20.4h-10l2.1-9.8H330l-2 9.8h-10l-4.4 20.4h-13.7z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M306 20.3h-10l1.4-6.9h30.7l-1.4 7h-10l-4.4 20.3h-10.7l4.3-20.4zM109.6 31H103l5.2-9.3 1.3 9.2zM86 40.6h11.5l1.8-3.1h11.3l.4 3.1h11.5l-5.8-27.2h-13.3L86 40.7z",
  fill: "#000"
}));
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-axelent_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h330v54H0z"
})));
function SvgLogoAxelent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 330 54"
  }, props), _ref, _ref2);
}
export default SvgLogoAxelent;